exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.listSellerTable {\n  border: 1px solid black;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.listSellerTable th, .listSellerTable td {\n  border: 1px solid black;\n  padding: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1feb94bd","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/LMSGiframe/ListSellersFromApplicationForm.vue
// module id = 1548
// module chunks = 2